<template lang="html">
  <div v-if="getLoadingAxiosState" class="__loading">
    <v-progress-linear indeterminate color="primary" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      overlay: true
    }
  },
  computed: {
    ...mapGetters(['getLoadingAxiosState'])
  }
}
</script>
